import apiService from './apiService';

const BASE_URL = '/dashboard/hr';

const hrDashboardService = {
  /**
   * Get employee count by status
   * @returns {Promise<Array<{status: string, count: number}>>}
   */
  async getEmployeeStatusSummary() {
    return apiService.get(`${BASE_URL}/employee-status-summary`);
  },

  /**
   * Get employees with missing required documents
   * @param {string} [phase] - Optional phase filter (e.g., 'Onboarding', 'Employment')
   * @returns {Promise<Array>}
   */
  async getMissingDocuments(phase = null) {
    const url = phase 
      ? `${BASE_URL}/missing-documents?phase=${encodeURIComponent(phase)}`
      : `${BASE_URL}/missing-documents`;
    return apiService.get(url);
  },

  /**
   * Get employees with probation ending soon
   * @param {number} [days=30] - Number of days to look ahead
   * @returns {Promise<Array>}
   */
  async getProbationEnding(days = 30) {
    return apiService.get(`${BASE_URL}/probation-ending?days=${days}`);
  },

  /**
   * Get fixed-term contracts expiring soon
   * @param {number} [days=60] - Number of days to look ahead
   * @returns {Promise<Array>}
   */
  async getContractsExpiring(days = 60) {
    return apiService.get(`${BASE_URL}/contracts-expiring?days=${days}`);
  },

  /**
   * Get documents expiring soon
   * @param {number} [days=30] - Number of days to look ahead
   * @returns {Promise<Array>}
   */
  async getDocumentsExpiring(days = 30) {
    return apiService.get(`${BASE_URL}/documents-expiring?days=${days}`);
  },

  /**
   * Get pending career event follow-ups
   * @returns {Promise<Array>}
   */
  async getPendingFollowUps() {
    return apiService.get(`${BASE_URL}/pending-followups`);
  },

  /**
   * Get unified action queue with KPI summary
   * @returns {Promise<{kpi: Object, items: Array}>}
   */
  async getActionQueue() {
    return apiService.get(`${BASE_URL}/action-queue`);
  }
};

export default hrDashboardService;

